import I18n from 'I18n';
import { useCallback, useContext } from 'react';
import { getCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplyGetters';
// @ts-expect-error module not typed
import { setCommonMessage } from 'conversations-thread-data/common-reply/public/operators/commonReplySetters';
import { getSenders } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getSenderField, getDeliveryIdentifier } from 'conversations-message-history/common-message-format/operators/senderGetters';
// TODO: move to composer-ui
import { getFromAddressChanged } from '../../../usage-tracking/events/metadataEditorInteractions';
import MetadataInputLabel from './MetadataInputLabel';
import ChannelInstanceSelect from './ChannelInstanceSelect';
import { useChannelInstancesForChannel } from 'conversations-thread-data/channel-instances/public/hooks';
import { EMAIL_GENERIC_CHANNEL_ID } from 'conversations-thread-data/generic-channels/public/constants';
import { updateSenders } from 'conversations-thread-data/common-reply/public/operators/updateSenders';
import { getDeliveryIdentifierType } from 'conversations-message-history/common-message-format/operators/deliveryIdentifierGetters';
import { EditorTrackerContext } from '../../../usage-tracking/context/EditorTrackerContext';
import { getCommonMessageDeliveryIdentifierValue } from 'composer-data/email-metadata/public/operators';
import { jsx as _jsx } from "react/jsx-runtime";
export const Sender = ({
  reply,
  onChange,
  inboxId,
  defaultSendFromEnabled
}) => {
  const commonMessage = getCommonMessage(reply);
  const senders = getSenders(commonMessage);
  const sender = senders && senders.first();
  const deliveryIdentifier = sender && getDeliveryIdentifier(sender);
  const deliveryIdentifierType = deliveryIdentifier ? getDeliveryIdentifierType(deliveryIdentifier) : '';
  const field = sender ? getSenderField(sender) : '';
  const {
    channelInstances
  } = useChannelInstancesForChannel({
    inboxId,
    channelId: EMAIL_GENERIC_CHANNEL_ID
  });
  const selectedValue = getCommonMessageDeliveryIdentifierValue(commonMessage) || '';
  const {
    trackEvent
  } = useContext(EditorTrackerContext);
  const handleFromChange = useCallback((deliveryIdentifierValue, nextConnectedAccount) => {
    if (channelInstances) {
      const updatedCommonMessage = updateSenders(deliveryIdentifierValue, channelInstances, deliveryIdentifierType, field || '', nextConnectedAccount, commonMessage);
      const updatedCommonReply = setCommonMessage(updatedCommonMessage, reply);
      onChange(updatedCommonReply);
      trackEvent(getFromAddressChanged());
    }
  }, [onChange, reply, deliveryIdentifierType, field, commonMessage, channelInstances, trackEvent]);
  return /*#__PURE__*/_jsx(MetadataInputLabel, {
    label: I18n.text('composer-ui.metadata-editor.sender.label'),
    children: /*#__PURE__*/_jsx(ChannelInstanceSelect, {
      inboxId: inboxId,
      onChange: handleFromChange,
      value: selectedValue,
      defaultSendFromEnabled: defaultSendFromEnabled
    })
  });
};
Sender.displayName = 'Sender';